// extracted by mini-css-extract-plugin
export var checkoutRateBadge = "_su-0";
export var checkoutRateBadgeLink = "_su-1";